import { render, staticRenderFns } from "./App.vue?vue&type=template&id=ddb8b216&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=ddb8b216&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb8b216",
  null
  
)

export default component.exports
import {QLayout,QHeader,QToolbar,QBtn,QToolbarTitle,QTabs,QRouteTab,QDrawer,QPageContainer,QBtnDropdown,QList,QPageSticky} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QHeader,QToolbar,QBtn,QToolbarTitle,QTabs,QRouteTab,QDrawer,QPageContainer,QBtnDropdown,QList,QPageSticky})
